export type PresentationMode = PRESENTATION_MODE.ER | PRESENTATION_MODE.STANDARD;

export enum PRESENTATION_MODE {
  ER = 'er',
  STANDARD = 'standard',
}
